import { render, staticRenderFns } from "./AddOtherprocurementedit.vue?vue&type=template&id=3684ddc8&scoped=true"
import script from "./AddOtherprocurementedit.vue?vue&type=script&lang=js"
export * from "./AddOtherprocurementedit.vue?vue&type=script&lang=js"
import style0 from "./AddOtherprocurementedit.vue?vue&type=style&index=0&id=3684ddc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684ddc8",
  null
  
)

export default component.exports